"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowMediumUpward = exports.shadowMedium = exports.shadowLow = exports.shadowHighest = exports.shadowHigh = exports.semanticWarningText = exports.semanticWarningBorderHover = exports.semanticWarningBackground = exports.semanticWarning = exports.semanticPositiveText = exports.semanticPositiveHover = exports.semanticPositiveBackground = exports.semanticPositive = exports.semanticInfoText = exports.semanticInfoStrongHover = exports.semanticInfoStrongBackground = exports.semanticInfoStrong = exports.semanticInfoHover = exports.semanticInfoBackground = exports.semanticInfo = exports.semanticErrorBorderHover = exports.semanticErrorBackground = exports.semanticError = exports.navigationItemHover = exports.navigationItemActive = exports.navigationItem = exports.contentWeak = exports.contentReverse = exports.contentDisabled = exports.content = exports.borderStrongHover = exports.borderStrong = exports.borderHover = exports.border = exports.backgroundStrong = exports.backgroundSecondary = exports.backgroundPrimary = exports.backgroundPage = exports.backgroundOverlay = exports.backgroundInactive = exports.backgroundHeader = exports.backgroundAccentPremierSavings = exports.backgroundAccentPL = exports.backgroundAccentDeposit = exports.backgroundAccentCard = exports.backgroundAccent = exports.actionableSecondary = exports.actionablePrimary = exports.actionableHover = exports.accentSecondary4 = exports.accentSecondary3 = exports.accentSecondary2 = exports.accentSecondary1 = exports.accentPrimary3 = exports.accentPrimary2 = exports.accentPrimary1 = void 0;
var actionablePrimary = "#0e680e";
exports.actionablePrimary = actionablePrimary;
var actionableHover = "#0a4007";
exports.actionableHover = actionableHover;
var actionableSecondary = "#1f63d2";
exports.actionableSecondary = actionableSecondary;
var navigationItem = "#3a3b41";
exports.navigationItem = navigationItem;
var navigationItemHover = "#1f63d2";
exports.navigationItemHover = navigationItemHover;
var navigationItemActive = "#0e680e";
exports.navigationItemActive = navigationItemActive;
var content = "#3a3b41";
exports.content = content;
var contentWeak = "#686c78";
exports.contentWeak = contentWeak;
var contentReverse = "#ffffff";
exports.contentReverse = contentReverse;
var contentDisabled = "#8e919c";
exports.contentDisabled = contentDisabled;
var border = "#cfd1d8";
exports.border = border;
var borderHover = "#8e919c";
exports.borderHover = borderHover;
var borderStrong = "#8e919c";
exports.borderStrong = borderStrong;
var borderStrongHover = "#3a3b41";
exports.borderStrongHover = borderStrongHover;
var backgroundPrimary = "#ffffff";
exports.backgroundPrimary = backgroundPrimary;
var backgroundPage = "#f6f6f9";
exports.backgroundPage = backgroundPage;
var backgroundInactive = "#cfd1d8";
exports.backgroundInactive = backgroundInactive;
var backgroundSecondary = "#f3f4f7";
exports.backgroundSecondary = backgroundSecondary;
var backgroundStrong = "#eaecf0";
exports.backgroundStrong = backgroundStrong;
var backgroundOverlay = "rgba(58, 59, 65, 0.5)";
exports.backgroundOverlay = backgroundOverlay;
var semanticPositive = "#4a9d2d";
exports.semanticPositive = semanticPositive;
var semanticPositiveText = "#0e680e";
exports.semanticPositiveText = semanticPositiveText;
var semanticPositiveHover = "#0e680e";
exports.semanticPositiveHover = semanticPositiveHover;
var semanticPositiveBackground = "#e8f5e6";
exports.semanticPositiveBackground = semanticPositiveBackground;
var semanticError = "#b52518";
exports.semanticError = semanticError;
var semanticErrorBorderHover = "#861008";
exports.semanticErrorBorderHover = semanticErrorBorderHover;
var semanticErrorBackground = "#fbeae9";
exports.semanticErrorBackground = semanticErrorBackground;
var semanticWarning = "#e2a439";
exports.semanticWarning = semanticWarning;
var semanticWarningText = "#906318";
exports.semanticWarningText = semanticWarningText;
var semanticWarningBorderHover = "#906318";
exports.semanticWarningBorderHover = semanticWarningBorderHover;
var semanticWarningBackground = "#faefdb";
exports.semanticWarningBackground = semanticWarningBackground;
var semanticInfo = "#8e919c";
exports.semanticInfo = semanticInfo;
var semanticInfoText = "#686c78";
exports.semanticInfoText = semanticInfoText;
var semanticInfoHover = "#686c78";
exports.semanticInfoHover = semanticInfoHover;
var semanticInfoBackground = "#f4f4f6";
exports.semanticInfoBackground = semanticInfoBackground;
var semanticInfoStrong = "#1f63d2";
exports.semanticInfoStrong = semanticInfoStrong;
var semanticInfoStrongHover = "#004d99";
exports.semanticInfoStrongHover = semanticInfoStrongHover;
var semanticInfoStrongBackground = "#e3f1f7";
exports.semanticInfoStrongBackground = semanticInfoStrongBackground;
var accentPrimary1 = "#4a9d2d";
exports.accentPrimary1 = accentPrimary1;
var accentPrimary2 = "#4899c4";
exports.accentPrimary2 = accentPrimary2;
var accentPrimary3 = "#e2a439";
exports.accentPrimary3 = accentPrimary3;
var accentSecondary1 = "#1f63d2";
exports.accentSecondary1 = accentSecondary1;
var accentSecondary2 = "#128079";
exports.accentSecondary2 = accentSecondary2;
var accentSecondary3 = "#3b128f";
exports.accentSecondary3 = accentSecondary3;
var accentSecondary4 = "#2d5477";
exports.accentSecondary4 = accentSecondary4;
var backgroundAccent = "#e0fff8";
exports.backgroundAccent = backgroundAccent;
var backgroundHeader = "#207C20";
exports.backgroundHeader = backgroundHeader;
var backgroundAccentCard = "#e8f5e6";
exports.backgroundAccentCard = backgroundAccentCard;
var backgroundAccentPL = "#f1ecf9";
exports.backgroundAccentPL = backgroundAccentPL;
var backgroundAccentDeposit = "#e3f1f7";
exports.backgroundAccentDeposit = backgroundAccentDeposit;
var backgroundAccentPremierSavings = "#14394e";
exports.backgroundAccentPremierSavings = backgroundAccentPremierSavings;
var shadowHighest = "rgba(58, 59, 65, 0.25)";
exports.shadowHighest = shadowHighest;
var shadowHigh = "rgba(58, 59, 65, 0.2)";
exports.shadowHigh = shadowHigh;
var shadowMedium = "rgba(58, 59, 65, 0.16)";
exports.shadowMedium = shadowMedium;
var shadowLow = "rgba(58, 59, 65, 0.1)";
exports.shadowLow = shadowLow;
var shadowMediumUpward = "rgba(58, 59, 65, 0.07)";
exports.shadowMediumUpward = shadowMediumUpward;
//# sourceMappingURL=upgrade.js.map